import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-check" }

import { ref } from 'vue'
import FilterCheckbox from '@/components/setup/FilterCheckbox.vue'
import { CommonCheckFilterType } from '@/types/filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonCheckFilters',
  props: {
    filters: {}
  },
  emits: ["updated", "summary"],
  setup(__props: any, { emit: __emit }) {



const filtersToEmit = ref<Record<string, boolean>>({})
const changeTypeFilter = (key: string, e: boolean) => {
  filtersToEmit.value[key] = e

  emits('updated', filtersToEmit.value)
}

const summary = ref<string[]>([])
const changeSummary = (label: string, e: boolean) => {
  if (e) {
    summary.value.push(label)
  } else {
    const index = summary.value.indexOf(label)

    if (index > -1) summary.value.splice(index, 1)
  }

  emits('summary', summary.value.join(', '))
}

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (value, key) => {
      return (_openBlock(), _createBlock(FilterCheckbox, {
        key: key,
        label: value.label,
        icons: value.icons,
        "onUpdate:modelValue": 
          (e) => {
            changeTypeFilter(key, e)
            changeSummary(value.label, e)
          }
        
      }, null, 8, ["label", "icons", "onUpdate:modelValue"]))
    }), 128))
  ]))
}
}

})